import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import styles from './SimpleFooter.module.scss';

const SimpleFooter = () => {
  const { t } = useTranslation('footer');

  return (
    <Container className={styles.simpleFooter}>
      <Row>
        <Col className={styles.center}>
          <div className={styles.shieldBackground}></div>
          <Image src="/images/footer/shield.svg" alt="Shield" width={221} height={285} priority />
        </Col>
      </Row>

      <Row className={`${styles.lint} mb-5`} />

      <Row>
        <Col sm={6} md={6} lg={9} xl={8}>
          <h3>{t('title.safe-environment')}</h3>
          <ul className="list-unstyled mb-3 mt-3">
            <li>
              <a href="/over-ons/leveringsvoorwaarden/">Leveringsvoorwaarden</a>
            </li>
            <li>
              <a href="/over-ons/privacy">Gebruiksovereenkomst</a>
            </li>
          </ul>
          © 2024 Carel Lurvink
        </Col>

        <Col sm={6} md={6} lg={3} xl={4}>
          <h3 className="mb-3">{t('title.iso-certifications')}</h3>
          <a href="/over-ons/certificering" target="_blank" rel="noopener noreferrer">
            <Image src="/images/footer/iso_9001.png" alt="ISO 9001" width={40} height={40} />
          </a>
          <a href="/over-ons/certificering" target="_blank" rel="noopener noreferrer">
            <Image src="/images/footer/iso_14001.png" alt="ISO 14001" width={40} height={40} />
          </a>
          <a href="/over-ons/certificering" target="_blank" rel="noopener noreferrer">
            <Image src="/images/footer/Hofleverancier.png" alt="Hofleverancier" width={40} height={40} />
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default SimpleFooter;
